import useLocaleHelper from "@/hooks/useLanguageHelper";

import PrivacyEnglish from "./markdown/PrivacyEnglish.mdx";
import PrivacyNorsk from "./markdown/PrivacyNorsk.mdx";

const markdownChoices = {
  no: PrivacyNorsk,
  en: PrivacyEnglish,
};

const PrivacyCopy = () => {
  const { currentLanguage } = useLocaleHelper();
  const Markdown = markdownChoices[currentLanguage];
  return <Markdown />;
};

export default PrivacyCopy;
